'use client';

import React from 'react';
import { PolicyModalShell } from './PolicyModalShell';

interface TermsOfServiceModalProps {
  alreadyAgreed?: boolean;
  isOpen: boolean;
  onAgree?: () => void;
  onClose: () => void;
}

export const TermsOfServiceModal: React.FC<TermsOfServiceModalProps> = ({ alreadyAgreed, isOpen, onAgree, onClose }) => {
  return (
    <PolicyModalShell alreadyAgreed={alreadyAgreed} isOpen={isOpen} onAgree={onAgree} onClose={onClose} title="서비스 이용약관">
      <h3 className="text-[20px] font-semibold">제1조 (목적)</h3>
      <p className="mb-2">
        이 약관은 <b>한림기술</b>(이하 &quot;회사&quot;라 합니다)이 운영하는 웹사이트(이하 &quot;사이트&quot;라 합니다)에서 제공하는 건설 관련 용역 컨설팅 및 제반 서비스(이하
        &quot;서비스&quot;라 합니다)를 이용함에 있어 회사와 이용자의 권리, 의무 및 책임사항을 규정함을 목적으로 합니다.
      </p>

      <h3 className="mt-4 text-[20px] font-semibold">제2조 (정의)</h3>
      <ol className="ml-4 list-decimal space-y-1">
        <li>
          &quot;사이트&quot;란 회사가 재화 또는 용역(이하 &quot;재화 등&quot;이라 합니다)을 이용자에게 제공하기 위하여 컴퓨터 등 정보통신설비를 이용하여 재화 등을 거래할 수 있도록
          설정한 가상의 영업장을 말합니다.
        </li>
        <li>&quot;이용자&quot;란 사이트에 접속하여 이 약관에 따라 회사가 제공하는 서비스를 받는 회원 및 비회원을 말합니다.</li>
        <li>
          &quot;회원&quot;이란 회사에 개인정보를 제공하여 회원등록을 한 자로서, 회사의 정보를 지속적으로 제공받으며 회사가 제공하는 서비스를 계속적으로 이용할 수 있는 자를
          말합니다.
        </li>
        <li>&quot;비회원&quot;이란 회원에 가입하지 않고 회사가 제공하는 서비스를 이용하는 자를 말합니다.</li>
        <li>&quot;컨설팅 서비스&quot;란 회사가 이용자의 요청에 따라 제공하는 건설 관련 자문, 보고서 작성, 기술 지원 등의 용역을 의미합니다.</li>
      </ol>

      <h3 className="mt-4 text-[20px] font-semibold">제3조 (약관 등의 명시와 설명 및 개정)</h3>
      <ol className="ml-4 list-decimal space-y-1">
        <li>
          회사는 이 약관의 내용과 상호 및 대표자 성명, 영업소 소재지 주소, 전화번호, 전자우편주소, 사업자등록번호, 통신판매업 신고번호, 개인정보 보호책임자 등을 이용자가 쉽게 알 수
          있도록 사이트의 초기 서비스화면(전면)에 게시합니다. 다만, 약관의 내용은 이용자가 연결화면을 통해 볼 수 있도록 할 수 있습니다.
        </li>
        <li>
          회사는 「전자상거래 등에서의 소비자보호에 관한 법률」, 「약관의 규제에 관한 법률」, 「전자문서 및 전자거래기본법」, 「전자서명법」, 「정보통신망 이용촉진 및 정보보호 등에
          관한 법률」, 「소비자기본법」 등 관련 법을 위배하지 않는 범위에서 이 약관을 개정할 수 있습니다.
        </li>
        <li>
          회사가 약관을 개정할 경우에는 적용일자 및 개정사유를 명시하여 현행약관과 함께 사이트의 초기화면에 그 적용일자 7일 이전부터 적용일자 전일까지 공지합니다. 다만, 이용자에게
          불리하게 약관내용을 변경하는 경우에는 최소한 30일 이상의 사전 유예기간을 두고 공지합니다.
        </li>
        <li>
          회사가 약관을 개정할 경우에는 그 개정약관은 그 적용일자 이후에 체결되는 계약에만 적용되고 그 이전에 이미 체결된 계약에 대해서는 개정 전의 약관조항이 그대로 적용됩니다.
          다만, 이미 계약을 체결한 이용자가 개정약관 조항의 적용을 받기를 원하는 뜻을 제3항에 의한 개정약관의 공지기간 내에 회사에 송신하여 회사의 동의를 받은 경우에는 개정약관
          조항이 적용됩니다.
        </li>
      </ol>

      <h3 className="mt-4 text-[20px] font-semibold">제4조 (서비스의 제공 및 변경)</h3>
      <ol className="ml-4 list-decimal space-y-1">
        <li>
          회사는 다음과 같은 업무를 수행합니다.
          <br />
          ① 각종 건설 관련 용역 컨설팅 및 자문
          <br />
          ② 건설 관련 정보 및 콘텐츠 제공
          <br />③ 기타 회사가 정하는 업무
        </li>
        <li>
          회사는 기술적 사양의 변경 또는 용역의 품절 등의 경우에는 장차 체결되는 계약에 의해 제공할 재화 또는 용역의 내용을 변경할 수 있습니다. 이 경우에는 변경된 내용 및
          제공일자를 명시하여 현재의 내용을 게시한 곳에 즉시 공지합니다.
        </li>
        <li>회사가 제공하기로 이용자와 계약을 체결한 서비스의 내용을 기술적 사양의 변경 등의 사유로 변경할 경우에는 그 사유를 이용자에게 통지 가능한 주소로 즉시 통지합니다.</li>
        <li>전항의 경우 회사는 이로 인하여 이용자가 입은 손해를 배상합니다. 다만, 회사가 고의 또는 과실이 없음을 입증하는 경우에는 그러하지 아니합니다.</li>
      </ol>

      <h3 className="mt-4 text-[20px] font-semibold">제5조 (서비스의 중단)</h3>
      <ol className="ml-4 list-decimal space-y-1">
        <li>회사는 컴퓨터 등 정보통신설비의 보수점검, 교체 및 고장, 통신의 두절 등의 사유가 발생한 경우에는 서비스의 제공을 일시적으로 중단할 수 있습니다.</li>
        <li>
          사업종목의 전환, 사업의 포기, 업체 간의 통합 등의 이유로 서비스를 제공할 수 없게 되는 경우에는 회사는 제8조에 정한 방법으로 이용자에게 통지하고 당초 회사에서 제시한
          조건에 따라 소비자에게 보상합니다.
        </li>
      </ol>

      <h3 className="mt-4 text-[20px] font-semibold">제6조 (회원가입)</h3>
      <ol className="ml-4 list-decimal space-y-1">
        <li>이용자는 회사가 정한 가입 양식에 따라 회원정보를 기입한 후 이 약관에 동의한다는 의사표시를 함으로써 회원가입을 신청합니다.</li>
        <li>
          회사는 제1항과 같이 회원으로 가입할 것을 신청한 이용자 중 다음 각 호에 해당하지 않는 한 회원으로 등록합니다.
          <br />
          ① 가입신청자가 이 약관 제7조 제3항에 의하여 이전에 회원자격을 상실한 적이 있는 경우
          <br />
          ② 등록 내용에 허위, 기재누락, 오기가 있는 경우
          <br />③ 기타 회원으로 등록하는 것이 회사의 기술상 현저히 지장이 있다고 판단되는 경우
        </li>
        <li>회원가입계약의 성립 시기는 회사의 승낙이 회원에게 도달한 시점으로 합니다.</li>
      </ol>

      <h3 className="mt-4 text-[20px] font-semibold">제7조 (회원 탈퇴 및 자격 상실 등)</h3>
      <ol className="ml-4 list-decimal space-y-1">
        <li>회원은 회사에 언제든지 탈퇴를 요청할 수 있으며 회사는 즉시 회원탈퇴를 처리합니다.</li>
        <li>
          회원이 다음 각 호의 사유에 해당하는 경우, 회사는 회원자격을 제한 및 정지시킬 수 있습니다.
          <br />
          ① 가입 신청 시에 허위 내용을 등록한 경우
          <br />
          ② 회사를 이용하여 구입한 재화 등의 대금, 기타 회사 이용에 관련하여 회원이 부담하는 채무를 기일에 지급하지 않는 경우
          <br />
          ③ 다른 사람의 회사 이용을 방해하거나 그 정보를 도용하는 등 전자상거래 질서를 위협하는 경우
          <br />④ 회사를 이용하여 법령 또는 이 약관이 금지하거나 공서양속에 반하는 행위를 하는 경우
        </li>
        <li>회사가 회원 자격을 제한·정지 시킨 후, 동일한 행위가 2회 이상 반복되거나 30일 이내에 그 사유가 시정되지 아니하는 경우 회사는 회원자격을 상실시킬 수 있습니다.</li>
      </ol>

      <h3 className="mt-4 text-[20px] font-semibold">제8조 (회원에 대한 통지)</h3>
      <ol className="ml-4 list-decimal space-y-1">
        <li>회사가 회원에 대한 통지를 하는 경우, 회원이 회사와 미리 약정하여 지정한 전자우편 주소 또는 휴대전화 문자메시지로 할 수 있습니다.</li>
        <li>회사는 불특정다수 회원에 대한 통지의 경우 1주일 이상 회사 게시판에 게시함으로써 개별 통지에 갈음할 수 있습니다.</li>
      </ol>

      <h3 className="mt-4 text-[20px] font-semibold">제9조 (개인정보보호)</h3>
      <ol className="ml-4 list-decimal space-y-1">
        <li>회사는 이용자의 개인정보 수집 시 서비스 제공을 위하여 필요한 범위에서 최소한의 개인정보를 수집합니다.</li>
        <li>회사는 이용자의 개인정보를 수집·이용하는 때에는 당해 이용자에게 그 목적을 고지하고 동의를 받습니다.</li>
        <li>
          회사는 수집된 개인정보를 목적 외의 용도로 이용할 수 없으며, 새로운 이용목적이 발생하거나 제3자에게 제공하는 경우에는 이용·제공 단계에서 당해 이용자에게 그 목적을 고지하고
          동의를 받습니다.
        </li>
        <li>기타 개인정보보호에 관한 상세한 내용은 회사가 별도로 정한 ‘개인정보처리방침’에 따릅니다.</li>
      </ol>

      <h3 className="mt-4 text-[20px] font-semibold">제10조 (회사의 의무)</h3>
      <ol className="ml-4 list-decimal space-y-1">
        <li>
          회사는 법령과 이 약관이 금지하거나 공서양속에 반하는 행위를 하지 않으며 이 약관이 정하는 바에 따라 지속적이고, 안정적으로 재화·용역을 제공하는 데 최선을 다하여야 합니다.
        </li>
        <li>회사는 이용자가 안전하게 인터넷 서비스를 이용할 수 있도록 이용자의 개인정보(신용정보 포함) 보호를 위한 보안 시스템을 갖추어야 합니다.</li>
        <li>회사는 이용자가 원하지 않는 영리목적의 광고성 전자우편을 발송하지 않습니다.</li>
      </ol>

      <h3 className="mt-4 text-[20px] font-semibold">제11조 (이용자의 의무)</h3>
      <p className="mb-2">이용자는 다음 행위를 하여서는 안 됩니다.</p>
      <ol className="ml-4 list-decimal space-y-1">
        <li>신청 또는 변경 시 허위 내용의 등록</li>
        <li>타인의 정보 도용</li>
        <li>회사가 게시한 정보의 변경</li>
        <li>회사가 정한 정보 이외의 정보(컴퓨터 프로그램 등) 등의 송신 또는 게시</li>
        <li>회사 및 기타 제3자의 저작권 등 지식재산권에 대한 침해</li>
        <li>회사 및 기타 제3자의 명예를 손상시키거나 업무를 방해하는 행위</li>
        <li>외설 또는 폭력적인 메시지, 화상, 음성, 기타 공서양속에 반하는 정보를 사이트에 공개 또는 게시하는 행위</li>
      </ol>

      <h3 className="text-[20px]font-semibold mt-4">제12조 (요금 및 유료서비스)</h3>
      <ol className="ml-4 list-decimal space-y-1">
        <li>회사가 제공하는 서비스는 기본적으로 무료입니다. 단, 별도의 유료 정보 및 전문 컨설팅 용역에 대해서는 해당 정보에 명시된 요금을 지불하여야 사용 가능합니다.</li>
        <li>이용고객이 납부해야 하는 요금과 요금의 납입 방법은 서비스별 안내에 따릅니다.</li>
      </ol>

      <h3 className="mt-4 text-[20px] font-semibold">제13조 (청약철회 및 환불)</h3>
      <ol className="ml-4 list-decimal space-y-1">
        <li>회사와 유료 서비스(컨설팅 등) 이용계약을 체결한 이용자는 계약 내용에 관한 서면을 받은 날(또는 서비스 이용 가능일)로부터 7일 이내에 청약을 철회할 수 있습니다.</li>
        <li>
          이용자는 다음 각 호의 어느 하나에 해당하는 경우에는 회사의 의사에 반하여 제1항에 따른 청약철회를 할 수 없습니다.
          <br />
          ① 이용자의 책임 있는 사유로 재화 등이 멸실되거나 훼손된 경우
          <br />
          ② 이용자의 사용 또는 일부 소비로 재화 등의 가치가 현저히 감소한 경우
          <br />
          ③ 용역(컨설팅)의 제공이 개시된 경우 (단, 가분적 용역으로 구성된 계약의 경우에는 제공이 개시되지 아니한 부분에 대하여는 그러하지 아니하다)
          <br />④ 이용자의 주문에 따라 개별적으로 생산되는 재화 또는 용역으로서 청약철회를 인정하면 회사에 회복할 수 없는 중대한 피해가 예상되는 경우로서 사전에 해당 거래에 대하여
          별도로 그 사실을 고지하고 이용자의 서면(전자문서 포함) 동의를 받은 경우
        </li>
        <li>
          제1항 및 제2항에도 불구하고 재화 등의 내용이 표시·광고 내용과 다르거나 계약내용과 다르게 이행된 때에는 당해 재화 등을 공급받은 날부터 3월 이내, 그 사실을 안 날 또는 알 수
          있었던 날부터 30일 이내에 청약철회 등을 할 수 있습니다.
        </li>
        <li>회사는 이용자로부터 재화 등을 반환받은 경우 3영업일 이내에 이미 지급받은 재화 등의 대금을 환급합니다.</li>
      </ol>

      <h3 className="mt-4 text-[20px] font-semibold">제14조 (저작권의 귀속 및 이용제한)</h3>
      <ol className="ml-4 list-decimal space-y-1">
        <li>이용자가 서비스 내에 게시한 게시물의 저작권은 해당 게시물의 저작자에게 귀속됩니다.</li>
        <li>회사가 작성한 저작물에 대한 저작권 및 기타 지식재산권은 회사에 귀속합니다.</li>
        <li>
          이용자는 서비스를 이용함으로써 얻은 정보 중 회사에게 지식재산권이 귀속된 정보를 회사의 사전 승낙 없이 복제, 송신, 출판, 배포, 방송 기타 방법에 의하여 영리목적으로
          이용하거나 제3자에게 이용하게 하여서는 안 됩니다.
        </li>
        <li>회사는 서비스의 운영, 전시, 전송, 배포, 홍보의 목적으로 회원의 별도 허락 없이 무상으로 저작물을 사용할 수 있습니다.</li>
      </ol>

      <h3 className="mt-4 text-[20px] font-semibold">제15조 (게시물의 관리)</h3>
      <ol className="ml-4 list-decimal space-y-1">
        <li>
          회사는 이용자가 게시하거나 등록하는 서비스 내의 내용물이 다음 각 호의 어느 하나에 해당한다고 판단되는 경우 사전통지 없이 삭제할 수 있습니다.
          <br />
          ① 다른 회원 또는 제3자를 비방하거나 중상모략으로 명예를 손상시키는 내용인 경우
          <br />
          ② 공공질서 및 미풍양속에 위반되는 내용인 경우
          <br />
          ③ 범죄적 행위에 결부된다고 인정되는 내용인 경우
          <br />
          ④ 회사의 저작권, 제3자의 저작권 등 기타 권리를 침해하는 내용인 경우
          <br />⑤ 기타 관계 법령에 위반된다고 판단되는 경우
        </li>
      </ol>

      <h3 className="mt-4 text-[20px] font-semibold">제16조 (손해배상 및 면책)</h3>
      <ol className="ml-4 list-decimal space-y-1">
        <li>회사는 천재지변 또는 이에 준하는 불가항력으로 인하여 서비스를 제공할 수 없는 경우에는 서비스 제공에 관한 책임이 면제됩니다.</li>
        <li>회사는 이용자의 귀책사유로 인한 서비스 이용의 장애에 대하여는 책임을 지지 않습니다.</li>
        <li>
          회사는 이용자가 서비스를 이용하여 기대하는 수익을 상실한 것에 대하여 책임을 지지 않으며, 그 밖의 서비스를 통하여 얻은 자료로 인한 손해에 관하여 책임을 지지 않습니다.
        </li>
        <li>회사가 제공하는 건설 컨설팅 결과물은 이용자의 의사결정을 위한 참고자료이며, 이를 실제 현장에 적용하여 발생한 결과 및 시공상의 책임은 전적으로 이용자에게 있습니다.</li>
      </ol>

      <h3 className="mt-4 text-[20px] font-semibold">제17조 (분쟁해결)</h3>
      <ol className="ml-4 list-decimal space-y-1">
        <li>회사는 이용자가 제기하는 정당한 의견이나 불만을 반영하고 그 피해를 보상처리하기 위하여 피해보상처리기구를 설치·운영합니다.</li>
        <li>
          회사는 이용자로부터 제출되는 불만사항 및 의견은 우선적으로 그 사항을 처리합니다. 다만, 신속한 처리가 곤란한 경우에는 이용자에게 그 사유와 처리일정을 즉시 통보해 드립니다.
        </li>
        <li>
          회사와 이용자 간에 발생한 전자상거래 분쟁과 관련하여 이용자의 피해구제신청이 있는 경우에는 공정거래위원회 또는 시·도지사가 의뢰하는 분쟁조정기관의 조정에 따를 수
          있습니다.
        </li>
      </ol>

      <h3 className="mt-4 text-[20px] font-semibold">제18조 (재판권 및 준거법)</h3>
      <ol className="ml-4 list-decimal space-y-1">
        <li>
          회사와 이용자 간에 발생한 전자상거래 분쟁에 관한 소송은 제소 당시의 이용자의 주소에 의하고, 주소가 없는 경우에는 거소를 관할하는 지방법원의 전속관할로 합니다. 다만, 제소
          당시 이용자의 주소 또는 거소가 분명하지 않거나 외국 거주자의 경우에는 민사소송법상의 관할법원에 제기합니다.
        </li>
        <li>회사와 이용자 간에 제기된 전자상거래 소송에는 대한민국법을 적용합니다.</li>
      </ol>
    </PolicyModalShell>
  );
};
